import { NotificationPreferenceApi } from '../../../api/users/models/notification-preference.api.model';
import { NotificationPreferenceTypes } from '../enums/notification-preference-types.enum';

export class NotificationPreferenceModel {
    subscriptionQuotaUsageWarnings?: boolean;
    subscriptionModerationWarnings?: NotificationPreferenceTypes;
    socialQuotaUsageWarnings?: boolean;
    socialModerationWarnings?: NotificationPreferenceTypes;
    alertExpirationWarnings?: NotificationPreferenceTypes;
    mentionQuotaWarnings?: boolean;
    topicModerationWarnings?: NotificationPreferenceTypes;
    distributionQuotaUsageWarnings?: boolean;

    constructor(apiEntity?: NotificationPreferenceApi) {
        if (apiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
     * Constructs this model from the provided API entity
     */
    private constructFromApiEntity(apiEntity: NotificationPreferenceApi): void {
        this.subscriptionQuotaUsageWarnings = apiEntity.subscriptionQuotaUsageWarnings === NotificationPreferenceTypes.ALL;
        this.subscriptionModerationWarnings = apiEntity.subscriptionModerationWarnings;
        this.socialQuotaUsageWarnings = apiEntity.socialQuotaUsageWarnings === NotificationPreferenceTypes.ALL;
        this.socialModerationWarnings = apiEntity.socialModerationWarnings;
        this.alertExpirationWarnings = apiEntity.alertExpirationWarnings;
        this.mentionQuotaWarnings = apiEntity.mentionQuotaWarnings === NotificationPreferenceTypes.ALL;
        this.topicModerationWarnings = apiEntity.topicModerationWarnings;
        this.distributionQuotaUsageWarnings = apiEntity.distributionQuotaUsageWarnings === NotificationPreferenceTypes.ALL;
    }

    /**
     * Constructs the default version of this model
     */
    private constructDefault(): void {
        this.subscriptionQuotaUsageWarnings = true;
        this.subscriptionModerationWarnings = NotificationPreferenceTypes.ALL;
        this.socialQuotaUsageWarnings = true;
        this.socialModerationWarnings = NotificationPreferenceTypes.ALL;
        this.alertExpirationWarnings = NotificationPreferenceTypes.ALL;
        this.mentionQuotaWarnings = true;
        this.topicModerationWarnings = NotificationPreferenceTypes.ALL;
        this.distributionQuotaUsageWarnings = true;
    }

    public toApiModel(): NotificationPreferenceApi {

        return {
            subscriptionQuotaUsageWarnings: this.subscriptionQuotaUsageWarnings ? NotificationPreferenceTypes.ALL : NotificationPreferenceTypes.NONE,
            subscriptionModerationWarnings: this.subscriptionModerationWarnings,
            socialQuotaUsageWarnings: this.socialQuotaUsageWarnings ? NotificationPreferenceTypes.ALL : NotificationPreferenceTypes.NONE,
            socialModerationWarnings: this.socialModerationWarnings,
            alertExpirationWarnings: this.alertExpirationWarnings,
            mentionQuotaWarnings: this.mentionQuotaWarnings ? NotificationPreferenceTypes.ALL : NotificationPreferenceTypes.NONE,
            topicModerationWarnings: this.topicModerationWarnings,
            distributionQuotaUsageWarnings: this.distributionQuotaUsageWarnings ? NotificationPreferenceTypes.ALL : NotificationPreferenceTypes.NONE,
        };
    }
}
